import React from 'react';

import type { DocSearchHit } from '../../../types';

import { NoResultsIcon } from './icons';
import type { ScreenStateProps } from './ScreenState';

type Props = ScreenStateProps<DocSearchHit>;

export const NoResultsScreen: React.FC<Props> = props => {
  const { state, setQuery, refresh, inputRef } = props;
  const searchSuggestions: string[] | undefined = state.context
    .searchSuggestions as string[];

  return (
    <div className="DocSearch-NoResults">
      <div className="DocSearch-Screen-Icon">
        <NoResultsIcon />
      </div>
      <p className="DocSearch-Title">
        No results for &quot;<strong>{state.query}</strong>&quot;
      </p>

      {searchSuggestions && searchSuggestions.length > 0 && (
        <div className="DocSearch-NoResults-Prefill-List">
          <p className="DocSearch-Help">Try searching for:</p>
          <ul>
            {searchSuggestions.slice(0, 3).reduce<React.ReactNode[]>(
              (acc, search) => [
                ...acc,
                <li key={search}>
                  <button
                    className="DocSearch-Prefill"
                    key={search}
                    type="button"
                    onClick={() => {
                      setQuery(`${search.toLowerCase()} `);
                      refresh();
                      if (inputRef.current) {
                        inputRef.current.focus();
                      }
                    }}
                  >
                    {search}
                  </button>
                </li>,
              ],
              [],
            )}
          </ul>
        </div>
      )}
    </div>
  );
};
